import React from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Creators as actions } from '../redux/actions';
import { KEY_KMPLAN } from '../constants/payment';

import { getSelectedFinancePlan, getSelectedFinanceOptions, getIntegerFormatter } from '../redux/selectors';



const SelectKmPlan = ({
    choices,
    updateKmPlan,
    value
}) => {
    const formatAsInteger = useSelector(getIntegerFormatter);

    const triggerChange = newValue => {
        if (value !== newValue) {
            updateKmPlan(newValue);
        }
    };

    return (
        <select
            id="calculator-kmplan-select"
            floatLabel
            value={value}
            onChange={e => triggerChange(e.target.value)}>
            {
                choices && choices.sort().map(val => (
                    <option value={val}>{formatAsInteger(val)}</option>
                ))
            }
        </select>
    );
};

SelectKmPlan.propTypes = {
    choices: PropTypes.arrayOf(Number),
    label: PropTypes.string,
    updateKmPlan: PropTypes.func,
    value: PropTypes.number
};

SelectKmPlan.defaultProps = {
    choices: [],
    updateKmPlan: () => {}
};

/**
 * @param {Object} state - Global state
 * @returns {Object} injected props
 */
const mapStateToProps = state => {
    const { kmPerYearPlans } = getSelectedFinancePlan(state);
    const financeOptions = getSelectedFinanceOptions(state);
    const { kmPerYearPlan } = financeOptions;
    return {
        choices: kmPerYearPlans,
        value: kmPerYearPlan
    };
};

/**
 * @param {Function} dispatch
 * @returns {Object} injected props
 */
const mapDispatchToProps = dispatch => ({
    updateKmPlan: value => dispatch(actions.changePaymentOptions({
        [KEY_KMPLAN]: parseInt(value, 10)
    }))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectKmPlan);
